export class GoogleLoginRequest {
    credential: string | undefined;
    device: string | undefined;
    applicationId: string | undefined;
    returnUrl: string | undefined;
}